import { Button as MuiButton, Typography } from "@mui/material";
import { spacing } from "@mui/system";
import React from "react";
import { Helmet } from "react-helmet-async";
import styled from "styled-components/macro";

import AuthPathBanner from "../../components/AuthPathBanner";
import useAuth from "../../hooks/useAuth";

const Button = styled(MuiButton)(spacing);

const Wrapper = styled.div`
  padding: ${(props) => props.theme.spacing(6)};
  text-align: center;
  background: transparent;

  ${(props) => props.theme.breakpoints.up("md")} {
    padding: ${(props) => props.theme.spacing(10)};
  }
`;

function NoDashboardAccess() {
  const { signOut } = useAuth();

  return (
    <Wrapper>
      <Helmet title="No dashboard access" />
      <AuthPathBanner sx={{ mb: 6, textAlign: "left" }} />
      <Typography component="h1" variant="h3" align="center" gutterBottom>
        You don't have dashboard access
      </Typography>
      <Typography component="p" variant="body1" align="center" gutterBottom>
        Ask your account manager to add it.
      </Typography>
      <Button onClick={signOut} variant="contained" color="secondary" mt={2}>
        Sign out
      </Button>
    </Wrapper>
  );
}

export default NoDashboardAccess;
